/**
 * URL state encoding/decoding for deep links and challenge links.
 */

/** Encode game state into URL params */
export function encodeGameUrl(params) {
  const url = new URL(window.location.href);
  url.search = '';

  if (params.targets?.length) {
    url.searchParams.set('stars', params.targets.map(t => {
      if (typeof t === 'string') return t;
      return (t.type === 'actor' ? 'a' : t.type === 'movie' ? 'm' : 't') + t.id;
    }).join(','));
  }

  if (params.board?.length) {
    url.searchParams.set('board', params.board.join(','));
  }

  if (params.room) {
    url.searchParams.set('room', params.room);
  }

  if (params.mode && params.mode !== 'custom') {
    url.searchParams.set('mode', params.mode);
  }

  if (params.options) {
    if (params.options.crewConnections) url.searchParams.set('crew', '1');
    if (params.options.scoring === 'chain-reaction') url.searchParams.set('scoring', 'chain');
    if (params.options.pathConstraints?.genre) url.searchParams.set('genre', params.options.pathConstraints.genre);
    if (params.options.pathConstraints?.decade) url.searchParams.set('decade', params.options.pathConstraints.decade);
    if (params.options.timeLimit) url.searchParams.set('time', String(params.options.timeLimit));
  }

  // Challenge link: author's board state
  if (params.challengeBoard) {
    url.searchParams.set('challenge', params.challengeBoard.join(','));
  }

  return url.toString();
}

/** Decode URL params into game state */
export function decodeGameUrl(urlString) {
  const url = new URL(urlString || window.location.href);
  const params = {};

  const stars = url.searchParams.get('stars');
  if (stars) {
    params.targets = stars.split(',').filter(Boolean);
  }

  const board = url.searchParams.get('board');
  if (board) {
    params.board = board.split(',').filter(Boolean);
  }

  const room = url.searchParams.get('room');
  if (room) {
    params.room = room;
  }

  const mode = url.searchParams.get('mode');
  if (mode) {
    params.mode = mode;
  }

  // Game options
  params.options = {};
  if (url.searchParams.get('crew') === '1') params.options.crewConnections = true;
  if (url.searchParams.get('scoring') === 'chain') params.options.scoring = 'chain-reaction';

  const genre = url.searchParams.get('genre');
  if (genre) params.options.genre = genre;

  const decade = url.searchParams.get('decade');
  if (decade) params.options.decade = decade;

  const time = url.searchParams.get('time');
  if (time) params.options.timeLimit = parseInt(time, 10);

  // Challenge link
  const challenge = url.searchParams.get('challenge');
  if (challenge) {
    params.challengeBoard = challenge.split(',').filter(Boolean);
  }

  return params;
}

/** Generate a share URL for current game */
export function getShareUrl(targets) {
  const url = new URL(window.location.origin + window.location.pathname);
  if (targets?.length) {
    url.searchParams.set('stars', targets.map(t => {
      if (typeof t === 'string') return t;
      return (t.type === 'actor' ? 'a' : t.type === 'movie' ? 'm' : 't') + t.id;
    }).join(','));
  }
  return url.toString();
}
